import * as React from "react";
import {Breadcrumbs, Typography, Container, Button, Box, Stack} from "@mui/material";
import AdviceHeader from "./AdviceHeader";
import {useState} from "react";
import AdviceDescriptionCard from "./AdviceDescriptionCard";
import AdviceDynamicPart from   "./AdviceDynamicPart";
import AdviceServiceRelateList from "./AdviceServiceRelateList";
import {useAdviceDetail} from "./hook/useAdviceDetail";
import { useParams } from "react-router-dom";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import {useNavigate} from "react-router-dom";
import {withAdviceDetailContext} from "../advice/state/adviceDetailContext";

const AdviceDetail = () => {
    const [anchor, setAnchor] = useState(0);
    const {id} = useParams();
    const {isLoading, advice} = useAdviceDetail(parseInt(id));
    const {mode} = useDarkMode();
    const navigate = useNavigate();
    console.log(isLoading, advice);
    const moveTo = (idAnchor) => {
        const tempPosition = idAnchor;
        const tempAnchor = 'anchor'+tempPosition;
        const anchorEl = document.getElementById(tempAnchor);
        console.log(anchorEl);
        if (anchorEl) {
            window.scrollTo({
                top: anchorEl.offsetTop - process.env.REACT_APP_HEADER_HEIGHT,
                behavior: "smooth",
            });
            setAnchor(idAnchor);
        }
    }
    return !isLoading && advice &&
        <Box>
             <Container maxWidth={"lg"} spacing={2}>
                 <Breadcrumbs separator="›" aria-label="breadcrumb" style={{color : mode.settings.textColor3, paddingTop: 15, paddingBottom: 15}}>
                     {[
                         <Typography className={'breadcrumbs'} variant={'body2'} onClick={() => navigate('/')} style={{color : mode.settings.breadcrumbColor1}}>
                             Accueil
                         </Typography>,
                         <Typography className={'breadcrumbs'} variant={'body2'} onClick={() => navigate('/product-search')} style={{color : mode.settings.breadcrumbColor1}}>
                             Conseil
                         </Typography>,
                         <Typography className={'breadcrumbs'} variant={'body2'} style={{color : mode.settings.textColor3}}>
                             Détail
                         </Typography>,
                     ]}
                 </Breadcrumbs>
                 <AdviceHeader advice={advice}></AdviceHeader> <br/><br/>
                     <Stack
                         component={'div'}
                         variant={'subtitle1'}
                         direction={"row"}
                         justifyContent={{xs : "center", md : "center" , lg : "space-between"}}
                         flexWrap={"wrap"}
                         sx={{mt : '20px', mb : '20px', width : 'inherit'}}
                         gap={2}
                     >
                         <Button className="buttonAdviceNav" onClick={() => {moveTo(0)}}><Typography variant={'subtitle3'}>Description</Typography></Button>
                         <Button className="buttonAdviceNav" onClick={() => {moveTo(1)}}><Typography variant={'subtitle3'}>Articles</Typography></Button>
                         <Button className="buttonAdviceNav" onClick={() => {moveTo(2)}}><Typography variant={'subtitle3'}>Services Associés</Typography></Button>
                         <Button className="buttonAdviceNav" onClick={() => {moveTo(3)}}><Typography variant={'subtitle3'}>Contact</Typography></Button>
                     </Stack>
                 { advice && <Box id={"anchor0"}><AdviceDescriptionCard advice={advice}></AdviceDescriptionCard></Box>}
            </Container>
            <br/>
            <Box id={"anchor1"}>
                {advice && <AdviceDynamicPart children={advice.children} categories={advice.categories}></AdviceDynamicPart>}
            </Box>
            <div id={"anchor2"}><AdviceServiceRelateList></AdviceServiceRelateList></div>
        </Box>
}

export default withAdviceDetailContext(AdviceDetail);
